import { Card, CardContent, Typography, Avatar, Box } from "@mui/material";
import { motion } from "framer-motion";

interface TestimonialCardProps {
  name: string;
  role: string;
  company: string;
  testimonial: string | string[];
  avatar: string;
  index: number;
}

export const TestimonialCard = ({
  name,
  role,
  company,
  testimonial,
  avatar,
  index,
}: TestimonialCardProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      style={{ height: "100%", width: "100%" }}
    >
      <Card
        sx={{
          height: "100%",
          transition: "all 0.3s ease-in-out",
          "&:hover": {
            transform: "translateY(-8px)",
            boxShadow: (theme) => theme.shadows[4],
          },
        }}
      >
        <CardContent
          sx={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box
            sx={{
              position: "relative",
              padding: 2,
              textAlign: "left",
            }}
          >
            {Array.isArray(testimonial) ? (
              testimonial.map((t, i) => (
                <Typography
                  key={i}
                  variant="body2"
                  color="text.secondary"
                  gutterBottom
                >
                  {t}
                </Typography>
              ))
            ) : (
              <Typography variant="body2" color="text.secondary">
                {testimonial}
              </Typography>
            )}
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
              padding: 2,
            }}
          >
            <Avatar src={avatar} alt={name} sx={{ width: 56, height: 56 }} />
            <Box>
              <Typography variant="subtitle1" sx={{ color: "secondary.main" }}>
                {name}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {role} at {company}
              </Typography>
            </Box>
          </Box>
        </CardContent>
      </Card>
    </motion.div>
  );
};
